export enum SalesReportViewType {
  ProductByDay = 1,
  LocationByDay = 2
}

(SalesReportViewType as any).__typeName = 'SalesReportViewType';
